// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f93263ae","845":"f8692e2c"}[chunkId] + ".chunk.js";
};